import HtmlElement from './HtmlElement';
import {Settings} from '../Settings';
import {$window, $body} from '../Constants';
import Header from '../Elements/Header';

/**
 * Javascript Wrapper for the Banner HTMLElement
 */
class Banner extends HtmlElement {
	onReady() {
		this.adjustHeight();

		this.$slider = this.$element.find('.bannerSlider');
		this.initSlider();
	}

	onResize() {
		this.adjustHeight();
	}

	adjustHeight() {
		if(Settings.bannerAdjust) {
			this.$element.css('margin-top', Header.getHeight());
		}
	}

	initSlider() {
		this.$slider.owlCarousel({
			items: 1,
            nav: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            onInitialized: (e) => {
                let $target = this.$slider.find('.owl-item').eq(e.item.index);
                this.adjustNavPosition($target.find('.bannerSlideContent'));

                let timeout;

                $window.on('resize', () => {
                    clearTimeout(timeout);

                    timeout = setTimeout(() => {
                        this.adjustNavPosition($target);
                    }, 500);
                });
            }
		});
	}

    adjustNavPosition($target) {
		let $buttonWrap = $target.find('.bannerSlideContentButtonWrap');

		this.$slider.find('.owl-nav').css({
			top: $buttonWrap.position().top + $buttonWrap.outerHeight(true),
			left: $target.position().left + $target.width()
		});
    }
}

export default (new Banner($body.find('.banner')));